function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module core/plugincollection
 */
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * Manages a list of CKEditor plugins, including loading, resolving dependencies and initialization.
 *
 * @mixes module:utils/emittermixin~EmitterMixin
 */

var PluginCollection = /*#__PURE__*/function () {
  /**
   * Creates an instance of the plugin collection class.
   * Allows loading and initializing plugins and their dependencies.
   * Allows providing a list of already loaded plugins. These plugins will not be destroyed along with this collection.
   *
   * @param {module:core/editor/editor~Editor|module:core/context~Context} context
   * @param {Array.<Function>} [availablePlugins] Plugins (constructors) which the collection will be able to use
   * when {@link module:core/plugincollection~PluginCollection#init} is used with the plugin names (strings, instead of constructors).
   * Usually, the editor will pass its built-in plugins to the collection so they can later be
   * used in `config.plugins` or `config.removePlugins` by names.
   * @param {Iterable.<Array>} contextPlugins A list of already initialized plugins represented by a
   * `[ PluginConstructor, pluginInstance ]` pair.
   */
  function PluginCollection(context) {
    var availablePlugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var contextPlugins = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, PluginCollection);

    /**
     * @protected
     * @type {module:core/editor/editor~Editor|module:core/context~Context}
     */
    this._context = context;
    /**
     * @protected
     * @type {Map}
     */

    this._plugins = new Map();
    /**
     * A map of plugin constructors that can be retrieved by their names.
     *
     * @protected
     * @type {Map.<String|Function,Function>}
     */

    this._availablePlugins = new Map();

    var _iterator = _createForOfIteratorHelper(availablePlugins),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var PluginConstructor = _step.value;

        if (PluginConstructor.pluginName) {
          this._availablePlugins.set(PluginConstructor.pluginName, PluginConstructor);
        }
      }
      /**
       * Map of {@link module:core/contextplugin~ContextPlugin context plugins} which can be retrieved by their constructors or instances.
       *
       * @protected
       * @type {Map<Function,Function>}
       */

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this._contextPlugins = new Map();

    var _iterator2 = _createForOfIteratorHelper(contextPlugins),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _ref3 = _step2.value;

        var _ref2 = _slicedToArray(_ref3, 2);

        var _PluginConstructor = _ref2[0];
        var pluginInstance = _ref2[1];

        this._contextPlugins.set(_PluginConstructor, pluginInstance);

        this._contextPlugins.set(pluginInstance, _PluginConstructor); // To make it possible to require a plugin by its name.


        if (_PluginConstructor.pluginName) {
          this._availablePlugins.set(_PluginConstructor.pluginName, _PluginConstructor);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  /**
   * Iterable interface.
   *
   * Returns `[ PluginConstructor, pluginInstance ]` pairs.
   *
   * @returns {Iterable.<Array>}
   */


  _createClass(PluginCollection, [{
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function value() {
      var _iterator3, _step3, entry;

      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this._plugins);
              _context.prev = 1;

              _iterator3.s();

            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context.next = 10;
                break;
              }

              entry = _step3.value;

              if (!(typeof entry[0] == 'function')) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return entry;

            case 8:
              _context.next = 3;
              break;

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);

              _iterator3.e(_context.t0);

            case 15:
              _context.prev = 15;

              _iterator3.f();

              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[1, 12, 15, 18]]);
    })
    /**
     * Gets the plugin instance by its constructor or name.
     *
     *		// Check if 'Clipboard' plugin was loaded.
     *		if ( editor.plugins.has( 'ClipboardPipeline' ) ) {
     *			// Get clipboard plugin instance
     *			const clipboard = editor.plugins.get( 'ClipboardPipeline' );
     *
     *			this.listenTo( clipboard, 'inputTransformation', ( evt, data ) => {
     *				// Do something on clipboard input.
     *			} );
     *		}
     *
     * **Note**: This method will throw an error if a plugin is not loaded. Use `{@link #has editor.plugins.has()}`
     * to check if a plugin is available.
     *
     * @param {Function|String} key The plugin constructor or {@link module:core/plugin~PluginInterface.pluginName name}.
     * @returns {module:core/plugin~PluginInterface}
     */

  }, {
    key: "get",
    value: function get(key) {
      var plugin = this._plugins.get(key);

      if (!plugin) {
        var pluginName = key;

        if (typeof key == 'function') {
          pluginName = key.pluginName || key.name;
        }
        /**
         * The plugin is not loaded and could not be obtained.
         *
         * Plugin classes (constructors) need to be provided to the editor and must be loaded before they can be obtained from
         * the plugin collection.
         * This is usually done in CKEditor 5 builds by setting the {@link module:core/editor/editor~Editor.builtinPlugins}
         * property.
         *
         * **Note**: You can use `{@link module:core/plugincollection~PluginCollection#has editor.plugins.has()}`
         * to check if a plugin was loaded.
         *
         * @error plugincollection-plugin-not-loaded
         * @param {String} plugin The name of the plugin which is not loaded.
         */


        throw new CKEditorError('plugincollection-plugin-not-loaded', this._context, {
          plugin: pluginName
        });
      }

      return plugin;
    }
    /**
     * Checks if a plugin is loaded.
     *
     *		// Check if the 'Clipboard' plugin was loaded.
     *		if ( editor.plugins.has( 'ClipboardPipeline' ) ) {
     *			// Now use the clipboard plugin instance:
     *			const clipboard = editor.plugins.get( 'ClipboardPipeline' );
     *
     *			// ...
     *		}
     *
     * @param {Function|String} key The plugin constructor or {@link module:core/plugin~PluginInterface.pluginName name}.
     * @returns {Boolean}
     */

  }, {
    key: "has",
    value: function has(key) {
      return this._plugins.has(key);
    }
    /**
     * Initializes a set of plugins and adds them to the collection.
     *
     * @param {Array.<Function|String>} plugins An array of {@link module:core/plugin~PluginInterface plugin constructors}
     * or {@link module:core/plugin~PluginInterface.pluginName plugin names}.
     * @param {Array.<String|Function>} [pluginsToRemove] Names of the plugins or plugin constructors
     * that should not be loaded (despite being specified in the `plugins` array).
     * @param {Array.<Function>} [pluginsSubstitutions] An array of {@link module:core/plugin~PluginInterface plugin constructors}
     * that will be used to replace plugins of the same names that were passed in `plugins` or that are in their dependency tree.
     * A useful option for replacing built-in plugins while creating tests (for mocking their APIs). Plugins that will be replaced
     * must follow these rules:
     *   * The new plugin must be a class.
     *   * The new plugin must be named.
     *   * Both plugins must not depend on other plugins.
     * @returns {Promise.<module:core/plugin~LoadedPlugins>} A promise which gets resolved once all plugins are loaded
     * and available in the collection.
     */

  }, {
    key: "init",
    value: function init(plugins) {
      var pluginsToRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var pluginsSubstitutions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      // Plugin initialization procedure consists of 2 main steps:
      // 1) collecting all available plugin constructors,
      // 2) verification whether all required plugins can be instantiated.
      //
      // In the first step, all plugin constructors, available in the provided `plugins` array and inside
      // plugin's dependencies (from the `Plugin.requires` array), are recursively collected and added to the existing
      // `this._availablePlugins` map, but without any verification at the given moment. Performing the verification
      // at this point (during the plugin constructor searching) would cause false errors to occur, that some plugin
      // is missing but in fact it may be defined further in the array as the dependency of other plugin. After
      // traversing the entire dependency tree, it will be checked if all required "top level" plugins are available.
      //
      // In the second step, the list of plugins that have not been explicitly removed is traversed to get all the
      // plugin constructors to be instantiated in the correct order and to validate against some rules. Finally, if
      // no plugin is missing and no other error has been found, they all will be instantiated.
      var that = this;
      var context = this._context;
      findAvailablePluginConstructors(plugins);
      validatePlugins(plugins);
      var pluginsToLoad = plugins.filter(function (plugin) {
        return !isPluginRemoved(plugin, pluginsToRemove);
      });

      var pluginConstructors = _toConsumableArray(getPluginConstructors(pluginsToLoad));

      substitutePlugins(pluginConstructors, pluginsSubstitutions);
      var pluginInstances = loadPlugins(pluginConstructors);
      return initPlugins(pluginInstances, 'init').then(function () {
        return initPlugins(pluginInstances, 'afterInit');
      }).then(function () {
        return pluginInstances;
      });

      function isPluginConstructor(plugin) {
        return typeof plugin === 'function';
      }

      function isContextPlugin(plugin) {
        return isPluginConstructor(plugin) && plugin.isContextPlugin;
      }

      function isPluginRemoved(plugin, pluginsToRemove) {
        return pluginsToRemove.some(function (removedPlugin) {
          if (removedPlugin === plugin) {
            return true;
          }

          if (getPluginName(plugin) === removedPlugin) {
            return true;
          }

          if (getPluginName(removedPlugin) === plugin) {
            return true;
          }

          return false;
        });
      }

      function getPluginName(plugin) {
        return isPluginConstructor(plugin) ? plugin.pluginName || plugin.name : plugin;
      }

      function findAvailablePluginConstructors(plugins) {
        var processed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
        plugins.forEach(function (plugin) {
          if (!isPluginConstructor(plugin)) {
            return;
          }

          if (processed.has(plugin)) {
            return;
          }

          processed.add(plugin);

          if (plugin.pluginName && !that._availablePlugins.has(plugin.pluginName)) {
            that._availablePlugins.set(plugin.pluginName, plugin);
          }

          if (plugin.requires) {
            findAvailablePluginConstructors(plugin.requires, processed);
          }
        });
      }

      function getPluginConstructors(plugins) {
        var processed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
        return plugins.map(function (plugin) {
          return isPluginConstructor(plugin) ? plugin : that._availablePlugins.get(plugin);
        }).reduce(function (result, plugin) {
          if (processed.has(plugin)) {
            return result;
          }

          processed.add(plugin);

          if (plugin.requires) {
            validatePlugins(plugin.requires, plugin);
            getPluginConstructors(plugin.requires, processed).forEach(function (plugin) {
              return result.add(plugin);
            });
          }

          return result.add(plugin);
        }, new Set());
      }

      function validatePlugins(plugins) {
        var parentPluginConstructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        plugins.map(function (plugin) {
          return isPluginConstructor(plugin) ? plugin : that._availablePlugins.get(plugin) || plugin;
        }).forEach(function (plugin) {
          checkMissingPlugin(plugin, parentPluginConstructor);
          checkContextPlugin(plugin, parentPluginConstructor);
          checkRemovedPlugin(plugin, parentPluginConstructor);
        });
      }

      function checkMissingPlugin(plugin, parentPluginConstructor) {
        if (isPluginConstructor(plugin)) {
          return;
        }

        if (parentPluginConstructor) {
          /**
           * A required "soft" dependency was not found on the plugin list.
           *
           * When configuring the editor, either prior to building (via
           * {@link module:core/editor/editor~Editor.builtinPlugins `Editor.builtinPlugins`}) or when
           * creating a new instance of the editor (e.g. via
           * {@link module:core/editor/editorconfig~EditorConfig#plugins `config.plugins`}), you need to provide
           * some of the dependencies for other plugins that you used.
           *
           * This error is thrown when one of these dependencies was not provided. The name of the missing plugin
           * can be found in `missingPlugin` and the plugin that required it in `requiredBy`.
           *
           * In order to resolve it, you need to import the missing plugin and add it to the
           * current list of plugins (`Editor.builtinPlugins` or `config.plugins`/`config.extraPlugins`).
           *
           * Soft requirements were introduced in version 26.0.0. If you happen to stumble upon this error
           * when upgrading to version 26.0.0, read also the
           * {@glink builds/guides/migration/migration-to-26 Migration to 26.0.0} guide.
           *
           * @error plugincollection-soft-required
           * @param {String} missingPlugin The name of the required plugin.
           * @param {String} requiredBy The name of the plugin that requires the other plugin.
           */
          throw new CKEditorError('plugincollection-soft-required', context, {
            missingPlugin: plugin,
            requiredBy: getPluginName(parentPluginConstructor)
          });
        }
        /**
         * A plugin is not available and could not be loaded.
         *
         * Plugin classes (constructors) need to be provided to the editor before they can be loaded by name.
         * This is usually done in CKEditor 5 builds by setting the {@link module:core/editor/editor~Editor.builtinPlugins}
         * property.
         *
         * **If you see this warning when using one of the {@glink builds/index CKEditor 5 Builds}**, it means
         * that you try to enable a plugin which was not included in that build. This may be due to a typo
         * in the plugin name or simply because that plugin is not a part of this build. In the latter scenario,
         * read more about {@glink builds/guides/development/custom-builds custom builds}.
         *
         * **If you see this warning when using one of the editor creators directly** (not a build), then it means
         * that you tried loading plugins by name. However, unlike CKEditor 4, CKEditor 5 does not implement a "plugin loader".
         * This means that CKEditor 5 does not know where to load the plugin modules from. Therefore, you need to
         * provide each plugin through a reference (as a constructor function). Check out the examples in
         * {@glink builds/guides/integration/advanced-setup#scenario-2-building-from-source "Building from source"}.
         *
         * @error plugincollection-plugin-not-found
         * @param {String} plugin The name of the plugin which could not be loaded.
         */


        throw new CKEditorError('plugincollection-plugin-not-found', context, {
          plugin: plugin
        });
      }

      function checkContextPlugin(plugin, parentPluginConstructor) {
        if (!isContextPlugin(parentPluginConstructor)) {
          return;
        }

        if (isContextPlugin(plugin)) {
          return;
        }
        /**
         * If a plugin is a context plugin, all plugins it requires should also be context plugins
         * instead of plugins. In other words, if one plugin can be used in the context,
         * all its requirements should also be ready to be used in the context. Note that the context
         * provides only a part of the API provided by the editor. If one plugin needs a full
         * editor API, all plugins which require it are considered as plugins that need a full
         * editor API.
         *
         * @error plugincollection-context-required
         * @param {String} plugin The name of the required plugin.
         * @param {String} requiredBy The name of the parent plugin.
         */


        throw new CKEditorError('plugincollection-context-required', context, {
          plugin: getPluginName(plugin),
          requiredBy: getPluginName(parentPluginConstructor)
        });
      }

      function checkRemovedPlugin(plugin, parentPluginConstructor) {
        if (!parentPluginConstructor) {
          return;
        }

        if (!isPluginRemoved(plugin, pluginsToRemove)) {
          return;
        }
        /**
         * Cannot load a plugin because one of its dependencies is listed in the `removePlugins` option.
         *
         * @error plugincollection-required
         * @param {String} plugin The name of the required plugin.
         * @param {String} requiredBy The name of the parent plugin.
         */


        throw new CKEditorError('plugincollection-required', context, {
          plugin: getPluginName(plugin),
          requiredBy: getPluginName(parentPluginConstructor)
        });
      }

      function loadPlugins(pluginConstructors) {
        return pluginConstructors.map(function (PluginConstructor) {
          var pluginInstance = that._contextPlugins.get(PluginConstructor) || new PluginConstructor(context);

          that._add(PluginConstructor, pluginInstance);

          return pluginInstance;
        });
      }

      function initPlugins(pluginInstances, method) {
        return pluginInstances.reduce(function (promise, plugin) {
          if (!plugin[method]) {
            return promise;
          }

          if (that._contextPlugins.has(plugin)) {
            return promise;
          }

          return promise.then(plugin[method].bind(plugin));
        }, Promise.resolve());
      } // Replaces plugin constructors with the specified set of plugins.
      //
      // @param {Array.<Function>} pluginConstructors
      // @param {Array.<Function>} pluginsSubstitutions


      function substitutePlugins(pluginConstructors, pluginsSubstitutions) {
        var _iterator4 = _createForOfIteratorHelper(pluginsSubstitutions),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var pluginItem = _step4.value;

            if (typeof pluginItem != 'function') {
              /**
               * The plugin replacing an existing plugin must be a function.
               *
               * @error plugincollection-replace-plugin-invalid-type
               */
              throw new CKEditorError('plugincollection-replace-plugin-invalid-type', null, {
                pluginItem: pluginItem
              });
            }

            var pluginName = pluginItem.pluginName;

            if (!pluginName) {
              /**
               * The plugin replacing an existing plugin must have a name.
               *
               * @error plugincollection-replace-plugin-missing-name
               */
              throw new CKEditorError('plugincollection-replace-plugin-missing-name', null, {
                pluginItem: pluginItem
              });
            }

            if (pluginItem.requires && pluginItem.requires.length) {
              /**
               * The plugin replacing an existing plugin cannot depend on other plugins.
               *
               * @error plugincollection-plugin-for-replacing-cannot-have-dependencies
               */
              throw new CKEditorError('plugincollection-plugin-for-replacing-cannot-have-dependencies', null, {
                pluginName: pluginName
              });
            }

            var pluginToReplace = that._availablePlugins.get(pluginName);

            if (!pluginToReplace) {
              /**
               * The replaced plugin does not exist in the
               * {@link module:core/plugincollection~PluginCollection available plugins} collection.
               *
               * @error plugincollection-plugin-for-replacing-not-exist
               */
              throw new CKEditorError('plugincollection-plugin-for-replacing-not-exist', null, {
                pluginName: pluginName
              });
            }

            var indexInPluginConstructors = pluginConstructors.indexOf(pluginToReplace);

            if (indexInPluginConstructors === -1) {
              // The Context feature can substitute plugins as well.
              // It may happen that the editor will be created with the given context, where the plugin for substitute
              // was already replaced. In such a case, we don't want to do it again.
              if (that._contextPlugins.has(pluginToReplace)) {
                return;
              }
              /**
               * The replaced plugin will not be loaded so it cannot be replaced.
               *
               * @error plugincollection-plugin-for-replacing-not-loaded
               */


              throw new CKEditorError('plugincollection-plugin-for-replacing-not-loaded', null, {
                pluginName: pluginName
              });
            }

            if (pluginToReplace.requires && pluginToReplace.requires.length) {
              /**
               * The replaced plugin cannot depend on other plugins.
               *
               * @error plugincollection-replaced-plugin-cannot-have-dependencies
               */
              throw new CKEditorError('plugincollection-replaced-plugin-cannot-have-dependencies', null, {
                pluginName: pluginName
              });
            }

            pluginConstructors.splice(indexInPluginConstructors, 1, pluginItem);

            that._availablePlugins.set(pluginName, pluginItem);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
    /**
     * Destroys all loaded plugins.
     *
     * @returns {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var promises = [];

      var _iterator5 = _createForOfIteratorHelper(this),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ref6 = _step5.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var pluginInstance = _ref5[1];

          if (typeof pluginInstance.destroy == 'function' && !this._contextPlugins.has(pluginInstance)) {
            promises.push(pluginInstance.destroy());
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return Promise.all(promises);
    }
    /**
     * Adds the plugin to the collection. Exposed mainly for testing purposes.
     *
     * @protected
     * @param {Function} PluginConstructor The plugin constructor.
     * @param {module:core/plugin~PluginInterface} plugin The instance of the plugin.
     */

  }, {
    key: "_add",
    value: function _add(PluginConstructor, plugin) {
      this._plugins.set(PluginConstructor, plugin);

      var pluginName = PluginConstructor.pluginName;

      if (!pluginName) {
        return;
      }

      if (this._plugins.has(pluginName)) {
        /**
         * Two plugins with the same {@link module:core/plugin~PluginInterface.pluginName} were loaded.
         * This will lead to runtime conflicts between these plugins.
         *
         * In practice, this warning usually means that new plugins were added to an existing CKEditor 5 build.
         * Plugins should always be added to a source version of the editor (`@ckeditor/ckeditor5-editor-*`),
         * not to an editor imported from one of the `@ckeditor/ckeditor5-build-*` packages.
         *
         * Check your import paths and the list of plugins passed to
         * {@link module:core/editor/editor~Editor.create `Editor.create()`}
         * or specified in {@link module:core/editor/editor~Editor.builtinPlugins `Editor.builtinPlugins`}.
         *
         * The second option is that your `node_modules/` directory contains duplicated versions of the same
         * CKEditor 5 packages. Normally, on clean installations, npm deduplicates packages in `node_modules/`, so
         * it may be enough to call `rm -rf node_modules && npm i`. However, if you installed conflicting versions
         * of some packages, their dependencies may need to be installed in more than one version which may lead to this
         * warning.
         *
         * Technically speaking, this error occurs because after adding a plugin to an existing editor build
         * the dependencies of this plugin are being duplicated.
         * They are already built into that editor build and now get added for the second time as dependencies
         * of the plugin you are installing.
         *
         * Read more about {@glink builds/guides/integration/installing-plugins installing plugins}.
         *
         * @error plugincollection-plugin-name-conflict
         * @param {String} pluginName The duplicated plugin name.
         * @param {Function} plugin1 The first plugin constructor.
         * @param {Function} plugin2 The second plugin constructor.
         */
        throw new CKEditorError('plugincollection-plugin-name-conflict', null, {
          pluginName: pluginName,
          plugin1: this._plugins.get(pluginName).constructor,
          plugin2: PluginConstructor
        });
      }

      this._plugins.set(pluginName, plugin);
    }
  }]);

  return PluginCollection;
}();

export { PluginCollection as default };
mix(PluginCollection, EmitterMixin);